function UserManagementIcon(props) {
  return (
    <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M21.92 6.846h-3.692V5h-3.69v1.846h-3.692C9.83 6.846 9 7.676 9 8.69v14.766c0 1.015.83 1.846 1.846 1.846H21.92c1.015 0 1.846-.83 1.846-1.846V8.691c0-1.015-.83-1.845-1.846-1.845zm-.923 15.688H11.77v-.923h9.228v.923zm0-2.768H11.77v-1.108c0-1.107 1.476-1.938 3.414-2.215.092-.184.185-.369.185-.553 0-.185-.093-.37-.093-.462-.646-.461-1.107-1.292-1.107-2.215-.092-1.476.923-2.676 2.215-2.676 1.292 0 2.307 1.2 2.307 2.584 0 .923-.462 1.753-1.108 2.215-.092.184-.092.277-.092.461 0 .185.093.37.185.554 1.938.277 3.414 1.2 3.414 2.215v1.2h-.092z" />
    </svg>
  )
}

export default UserManagementIcon
